var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Icon } from "sb-resp-ui";
var baseClass = "rj-yourbet__remove";
var Remove = /** @class */ (function (_super) {
    __extends(Remove, _super);
    function Remove() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Remove.prototype.render = function () {
        var _a = this.props, modifier = _a.modifier, datauat = _a.datauat, icon = _a.icon, handler = _a.handler;
        var cls = "" + baseClass + (modifier ? " " + baseClass + "--" + modifier : "");
        return (React.createElement("button", { type: "button", className: cls, onClick: handler },
            React.createElement(Icon, { i: icon, "data-uat": datauat })));
    };
    return Remove;
}(React.Component));
export { Remove };
//# sourceMappingURL=Remove.js.map